import { Component, inject } from '@angular/core';
import { AllUsersTableComponent } from '../../partials/all-users-table/all-users-table.component';
import { COMMON_IMPORTS } from '../../../../Shared/common-imports';
import { FormControl } from '@angular/forms';
import { ListUsersFacade } from '../../../../../Facades/Intune/list-users.facade';
import { debounceTime, filter } from 'rxjs/operators';

@Component({
  selector: 'app-dashboard',
  imports: [COMMON_IMPORTS, AllUsersTableComponent],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss', '../../../../../../assets/theme/cutom/_error-container.scss'],
})
export class DashboardComponent {
  readonly facade = inject(ListUsersFacade);

  searchControl = new FormControl<string>('');

  constructor() {
    this.initSearch();
  }

  initSearch() {
    this.searchControl
      .valueChanges.pipe(
        debounceTime(500),
        filter((value: string | null) => value !== null && (value.length === 0 || value.length >= 2)))
      .subscribe((value: string | null) => {
        this.facade.setSearchTerm(value ?? '');
      });
  }
}
